package com.iregained.eventapp.components.sections.event_details.styles

import com.iregained.eventapp.utils.Res
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.auto

val HeroSectionStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .backgroundColor(Res.IRColors.SurfaceBright)
            .borderBottom(1.px, LineStyle.Solid, Res.IRColors.OutlineVariant)
    }
}

val HeroContainerStyle = CssStyle {
    base {
        Modifier
            .maxWidth(1280.px)
            .styleModifier {
                property("margin-left", "auto")
                property("margin-right", "auto")
            }
            .display(DisplayStyle.Grid)
            // Mobile: 1 column
            .gridTemplateColumns { size(1.fr) }
            .gap(2.cssRem)
            .padding(leftRight = 2.cssRem, topBottom = 2.cssRem)
    }
    Breakpoint.MD {
        // Desktop: 2 columns
        Modifier.gridTemplateColumns { size(1.fr); size(1.fr) }
    }
}